export function callEveryAt<T>(count: number, fun: any) {
  let calls = 0;
  return (...arg: any): T | undefined => {
    calls += 1;
    if (calls % count === 0) {
      return fun(...arg);
    }
  };
}
